import {CalculatorOptions} from '../../../shared/classes/CalculatorOptions';
import {CalculatorInputFieldsKey, FieldConfiguration, inputConfig} from "./config/input.config";

export type {CalculatorInputFieldsKey} from './config/input.config';
export type CalculatorInputFieldsType = Record<CalculatorInputFieldsKey, number | null | undefined>;

export const CalculatorInputFields: ReadonlyArray<FieldConfiguration> = inputConfig as ReadonlyArray<FieldConfiguration>;
// les données vont être remplies juste en dessous, pas de soucis
export const CalculatorInputFieldsValues: CalculatorInputFieldsType = {} as CalculatorInputFieldsType;
export const CalculatorInputOptions: Partial<Record<CalculatorInputFieldsKey, CalculatorOptions>> = {};

// on construit les CalculatorInputOptions depuis le tableau de configuration
for (const field of inputConfig) {
    const {key, defaultValue, cell, label, ...options } = field as FieldConfiguration;
    // @ts-ignore
    CalculatorInputOptions[key] = options || {};
    // @ts-ignore
    CalculatorInputFieldsValues[key] = defaultValue
}













